<template>
  <div v-if="article">
    <h1>Figures</h1>
    <section v-for="figure in article.files.figures">
      <h2>{{figure.label}}</h2>
      <div><img :src="figure.url"/></div>
      <p v-html="figure.caption"></p>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'interact',
    data () {
      return {
        article: false
      }
    },
    created () {
      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
      }
      this.$parent.$parent.prevPage = {name: 'article-metrics'}
      this.$parent.$parent.nextPage = {name: 'article-media'}
      this.$parent.$parent.prevSlide = {name: 'article-interact-tables'}
      this.$parent.$parent.nextSlide = {name: 'article-interact-video'}
    }
  }
</script>


<style scoped lang="scss">
  h1 {
    color: $primary-color;
    font-weight: 300;
    font-size: 24px;
    text-transform: uppercase;
  }
  h2 {
    color: $primary-color;
    font-weight: 300;
    font-size: 18px;
    text-transform: uppercase;
  }
  .article-quick-links {
    margin-bottom: 40px;
  }
  section {
    div {
      text-align: center;
      img {
        width: 70%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// InteractFiguresPage.vue?623582a3